module.exports = __webpack_public_path__ + "static/media/bg_mainContainer_image.1e09afd4.jpg";